/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileAutodeskLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileAutodeskLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m30.724 53.118 7.05-5.26a1.434 1.434 0 0 0-.858-2.585H33.63a.727.727 0 0 1-.684-.976l3.372-9.273a.727.727 0 0 1 1.367 0l6.553 18.019a1.455 1.455 0 0 0 1.366.957h5.631a1.454 1.454 0 0 0 1.367-1.952l-10.578-29.09A1.455 1.455 0 0 0 40.657 22h-7.312a1.455 1.455 0 0 0-1.367.956l-7.89 21.64a1.453 1.453 0 0 0 .142 1.284l4.398 6.855a1.455 1.455 0 0 0 2.095.382Z",
        fill: "#3BA0F3"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m30.723 53.123 7.056-5.226a1.455 1.455 0 0 0-.866-2.624H24.374a.29.29 0 0 0-.244.448l4.502 7.02a1.454 1.454 0 0 0 2.091.382Z",
        fill: "#00D6B6"
      }
    )
  );
};
export {
  FileAutodeskLarge
};
